import ZkCol from './src/col.js'

/* istanbul ignore next */
ZkCol.install = function(Vue) {
  Vue.component(ZkCol.name, ZkCol)
}

export default ZkCol




// WEBPACK FOOTER //
// ./src/packages/col/index.js